import {AppModel, AppModelActions} from '../mappers/AppTypesMapper';
import {SET_APP_DATA, SET_APPLICATION_NAME, SET_HOSPITAL_ID, SET_MSAL_CONFIG_DATA} from '../actions';
import produce, {Draft} from 'immer';

export const initialAppState: AppModel = {
  responsiveMenu: false,
  applicationName: localStorage.getItem('applicationName') ?? '',
  hospitalId: localStorage.getItem('hospitalId') ?? '',
};

export const appReducer = produce(
  (state: Draft<AppModel>, action: AppModelActions) => {
    switch (action.type) {
      case SET_APP_DATA:
        state.responsiveMenu = !state.responsiveMenu;
        break;

      case SET_APPLICATION_NAME:
        state.applicationName = action.payload.applicationName || '';
        break;

      case SET_MSAL_CONFIG_DATA:
        state.authConfig = action.payload.authConfig || {};
        break;
      case SET_HOSPITAL_ID:
          state.hospitalId = action.payload.hospitalId || '';
          break;
        default:
        // Ensure exhaustive checking for action types
        throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
    }
  },
  initialAppState
);
